import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { formatPrice } from '../../../utils/formatPrice'

export function Card({ title, rankingList, pedidos }) {
  const summary = rankingList?.reduce(
    (acc, item) => {
      if (item.codigo_usuario !== '0') {
        const { valor_vendas_mes, valor_pedidos_mes } = item

        const valorVenda = parseFloat(valor_vendas_mes)
        const valorPedido = parseFloat(valor_pedidos_mes)

        acc.valor_vendas_mes += valorVenda
        acc.valor_pedidos_mes += valorPedido

        return acc
      }
      return acc
    },
    {
      valor_vendas_mes: 0,
      valor_pedidos_mes: 0,
    }
  )
  return (
    <Box
      maxW={'319'}
      w={'100%'}
      boxShadow={'0px 3px 6px #00000029'}
      bgColor={'#fff'}
      minH={'480px'}
      paddingInline={'14px'}
      paddingTop={'13px'}
      display={'flex'}
      flexDir={'column'}
      alignItems={'center'}
      justifyContent={'flex-start'}
    >
      <Text
        as={'h1'}
        textAlign={'center'}
        paddingBlock={'5px'}
        display={'block'}
        width={'100%'}
        color={'#fff'}
        bgColor={'#378BBF'}
        textTransform={'uppercase'}
        fontWeight={'600'}
      >
        {title}
      </Text>

      <Text
        as={'h1'}
        paddingBlock={'5px'}
        color={'#000'}
        bgColor={'#F5F5F5'}
        marginTop={'5px'}
        textAlign={'center'}
        display={'block'}
        width={'100%'}
      >
        {'1ª Lugar - ' + rankingList[0]?.vendedor?.nome_vendedor
          ? rankingList[0]?.vendedor?.nome_vendedor
          : 'Carregando...'}
      </Text>

      <Flex w={'100%'} flexDir={'column'} mt={'5px'}>
        <Flex
          w={'100%'}
          bgColor={'#378BBF'}
          paddingBlock={'13px'}
          alignItems={'center'}
          justifyContent={'center'}
          paddingInline={'23px'}
          color={'#fff'}
        >
          <Text
            as={'h1'}
            fontSize={'1rem'}
            fontWeight={'600'}
            textAlign={'center'}
          >
            {!pedidos ? 'Valor' : 'Pedidos'}
          </Text>
        </Flex>
        <Flex w={'100%'} gap={2} mt={'4px'}>
          <Flex
            w={'100%'}
            paddingBlock={'5px'}
            alignItems={'center'}
            justifyContent={'space-between'}
            flexDir={'column'}
          >
            {rankingList?.map((item, index) => {
              if (item.codigo_usuario !== '0') {
                return (
                  <Text
                    paddingBlock={'4px'}
                    bgColor={index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'}
                    display={'block'}
                    width={'100%'}
                    textAlign={'center'}
                  >
                    {!pedidos
                      ? formatPrice(item.valor_vendas_mes)
                      : item.valor_pedidos_mes}
                  </Text>
                )
              }
            })}
          </Flex>
        </Flex>
        <Flex
          w={'100%'}
          paddingBlock={'5px'}
          alignItems={'center'}
          justifyContent={'space-between'}
          gap={2}
          color={'#fff'}
        >
          <Text
            paddingBlock={'4px'}
            bg={'#378BBF'}
            display={'block'}
            width={'100%'}
            textAlign={'center'}
          >
            Total:{' '}
            {!pedidos
              ? formatPrice(summary?.valor_vendas_mes)
              : summary?.valor_pedidos_mes}
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}
